import { apiSlice } from "../../app/api/apiSlice";

export const fetchEnhancedConditionsTemplatesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		enhancedConditionsTemplates: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/get_enhanced_conditions_templates`,
				method: "GET",
			}),
		}),
	}),
});

export const { useEnhancedConditionsTemplatesMutation } = fetchEnhancedConditionsTemplatesApiSlice;
